"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import CopyButton from "../../buttons/CopyButton/CopyButton.js";
import { useLocaleText } from "../../../hooks/useLocaleText.js";
import TextLink from "../../navigation/TextLink/TextLink.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import Heading from "../../typography/Heading/Heading.js";
import { toKebabCase } from "../../../utilities/index.js";
import { Box } from "@mantine/core";
import { forwardRef, useState, memo } from "react";
import Grid from "../Grid/Grid.js";
import Group from "../Group/Group.js";
import '../../../assets/Section.css';const head = "_head_uxdv0_2";
const header = "_header_uxdv0_10";
const copyButton = "_copyButton_uxdv0_18";
const content = "_content_uxdv0_24";
const SectionStyles = {
  head,
  header,
  copyButton,
  content
};
const _Section = forwardRef((props, ref) => {
  const { header: header2, id, link, children, centerHeader, ...rest } = props;
  const texts = useLocaleText();
  const [clicked, setClicked] = useState(false);
  const timeout = 2e3;
  const anchorId = id || header2 && toKebabCase(header2) || void 0;
  const anchor = `#${anchorId}`;
  const clickHandler = () => {
    setClicked(true);
    setTimeout(() => {
      setClicked(false);
    }, timeout);
  };
  return /* @__PURE__ */ jsxs(Box, { ...rest, children: [
    (header2 || link) && /* @__PURE__ */ jsxs(
      Group,
      {
        className: SectionStyles.head,
        mb: children ? "md" : void 0,
        spacing: link ? "xl" : 0,
        ref,
        id: anchorId,
        children: [
          header2 && /* @__PURE__ */ jsxs(Group, { spacing: 0, justify: "space-between", children: [
            /* @__PURE__ */ jsx(
              Heading,
              {
                text: header2,
                className: SectionStyles.header,
                onClick: clickHandler,
                align: centerHeader ? "center" : void 0,
                type: "h2"
              }
            ),
            /* @__PURE__ */ jsx("div", { children: anchorId && !centerHeader ? /* @__PURE__ */ jsx(
              CopyButton,
              {
                control: clicked,
                text: anchor,
                notificationLabel: texts.linkCopied,
                copyLabel: "",
                copiedLabel: "",
                ml: "sm",
                timeout,
                className: SectionStyles.copyButton,
                variant: "anchor"
              }
            ) : null })
          ] }),
          link && /* @__PURE__ */ jsx(
            TextLink,
            {
              variant: "component",
              icon: "ChevronRight",
              iconPlacement: "right",
              text: link.text || texts.seeMore,
              href: link.href,
              target: "_self"
            }
          )
        ]
      }
    ),
    children && /* @__PURE__ */ jsx(Grid, { container: true, className: SectionStyles.content, children: /* @__PURE__ */ jsx(Grid, { item: true, children }) })
  ] });
});
_Section.displayName = "Section";
const Section = sharedHandler(memo(_Section));
Section.displayName = _Section.displayName;
export {
  SectionStyles as S,
  Section as default
};
